// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1eMV0","newTitle":"styles_newTitle__GtJ2f","paragraph":"styles_paragraph__B2qsO","link":"styles_link__2c7YL","gradient":"styles_gradient__262CO"};